import { Helmet } from "react-helmet-async";

import ContactHero from "../components/ContactHero";
import ContactSection from "../components/ContactSection";
import ContactForm from "../components/ContactForm";

export default function ContactPage() {
  return (
    <>
      <Helmet>
        <title>
          Contact Us | TanBio BioMed Genomics Laboratory
        </title>

        <meta
          name="description"
          content="Contact TanBio BioMed Genomics Laboratory for appointments, laboratory tests, preventive health checkups and diagnostic services."
        />

        <link rel="canonical" href="https://tanbiomedlab.com/contact" />
      </Helmet>

      <section id="contact-hero">
        <ContactHero />
      </section>

      <section id="contact">
        <ContactSection />
      </section>

      <section id="contact-form">
        <ContactForm />
      </section>
    </>
  );
}